module.exports = __webpack_public_path__ + "static/Group 183-42c45409e0f988e122c4dce4d7f997bd.svg";